import {
    convertStringToNumber,
    searchArray,
    searchArrayWithActive,
    sortArrayOfObject,
    sortArrayOfObjectByNumber
} from "./CommonFunction";
import {getDateInMonth, getDateInUTCByMonth} from "./DateFormat";
import React from "react";

export const surveyReportsData = (response, siteData, surveyName) => {
    let reportData = [];

    if (response && response.length) {
        response.forEach(responseObj => {
            let objectData = Object.assign({}, responseObj);

            if (objectData.survey === surveyName) {
                let siteObject = searchArray(objectData.site, siteData, "site");

                let obj = {
                    "Plant": siteObject.plant,
                    "Plant Cost Center": siteObject.plantHc,
                    "Site Id": siteObject.siteId,
                    "Site": siteObject.site,
                    "Survey Date": getDateInUTCByMonth(objectData.surveyDate),
                    "Survey Status": objectData.status === 2 ? "Completed" : "Not Completed"
                };

                if (objectData.surveyDetail && objectData.surveyDetail.length) {
                    objectData.surveyDetail.map(surveyObj => {
                        let surveyDetail = Object.assign({}, surveyObj);
                        //&& surveyDetail.value - remove to display the data is null headers into Excel file
                        if (surveyDetail && surveyDetail.fieldName ) {
                            if (surveyDetail.fieldName === "Date") {
                                obj[surveyDetail.fieldName] = getDateInUTCByMonth(surveyDetail.value);
                            } else {
                                obj[surveyDetail.fieldName] = surveyDetail.value;
                            }
                        }
                    });
                }
                reportData.push(obj);
            }
        });
    }

    return reportData;
};

export const scorecardReportData = (response, siteData) => {
    let reportData = [];

    if (response && response.length) {
        response.forEach(obj => {
            let objectData = Object.assign({}, obj);
            let siteObject = searchArray(objectData.site, siteData, "site");
            let data = {
                "Plant": siteObject.plant,
                "Plant Cost Center": siteObject.plantHc,
                "Site Id": siteObject.siteId,
                "Site": siteObject.site,
                "Survey Date": objectData.dateOfSurvey,
                "Soil Clean%": objectData.soilCleanRatio,
                "Total Number of Deliveries": objectData.totalDeliveries,
                "Number of Late Deliveries": objectData.lateDeliveries,
                "On Time Delivery%": objectData.onTimeDeliveryPercent,
                "Fill Rate %": objectData.fillRate,
                "User Id": objectData.userId,
                "User Name": objectData.username,
                "Date Range": objectData.dateRange,
            };
            reportData.push(data);
        });
    }

    return reportData;
};

export const utilizationReportData = (response, siteData) => {
    let reportData = [];

    if (response && response.length) {
        response.forEach(obj => {
            let objectData = Object.assign({}, obj);
            let siteObject = searchArray(objectData.site, siteData, "site");
            let data = {
                "Plant": siteObject.plant,
                "Plant Cost Center": siteObject.plantHc,
                "Site Id": siteObject.siteId,
                "Site": siteObject.site,
                "Survey Date": objectData.dateOfSurvey,
                "Adjusted Patient Days": objectData.patientDaysAdjusted,
                "Patient Days": objectData.patientDays,
                "Total Clean Pounds": objectData.totalCleanPounds,
                "Total Invoice Amount%": objectData.totalInvoice,
                "User Id": objectData.userId,
                "User Name": objectData.username,
                "Date Range": objectData.dateRange,
                "Pd Rqd.": !!siteObject.pdRqd,
                "Adp Rqd.": !!siteObject.apdRqd,
                "Clean Lbs.": !!siteObject.cleanLbs,
                "Inv$": !!siteObject.inv
            };
            reportData.push(data);
        });
    }

    return reportData;
};

export const masterReportData = (response) => {
    let reportData = [];

    response.forEach(siteObject => {
        let objectData = Object.assign({}, siteObject);
        let obj = {
            "Plant": objectData.plant,
            "Plant Cost Center": objectData.plantHc,
            "Site Id": objectData.siteId,
            "Site": objectData.site,
            "Site Status": objectData.siteStatus,
            "CLS Division": objectData.division,
            "CLS Region": objectData.region,
            "Sam": objectData.sam,
            "Annual Volume": objectData.annualVolume,
            "Security Group": objectData.idnAffiliation,
            "Visit Frequency": objectData.visitFrequency,
            "CV": objectData.requiredCV,
            "CS": objectData.requiredCS,
            "EU": objectData.requiredEU,
            "QA": objectData.requiredQA,
            "PAR": objectData.requiredPAR,
            "LL": objectData.requiredLL,
            "LA Committee": objectData.LArequiredCommittee,
            "LCCommittee": objectData.LCrequiredCommittee,
            "QBRs": objectData.requiredQBRs,
            "Add On Sales": objectData.addOnSales,
            "DVP": objectData.dvp,
            "RM": objectData.rm,
            "GM": objectData.gm,
            "TraumaLevel": objectData.traumaLevel,
            "ContactName1": objectData.contactName1,
            "ContactEmail 1": objectData.contactEmail1,
            "Contact Phone 1": objectData.contactPhone1,
            "ContactName 2": objectData.contactName2,
            "ContactEmail 2": objectData.contactEmail2,
            "ContactPhone 2": objectData.contactPhone2,
            "ContactName 3": objectData.contactName3,
            "ContactEmail 3": objectData.contactEmail3,
            "ContactPhone 3": objectData.contactPhone3,
            "ContactName 4": objectData.contactName4,
            "ContactEmail 4": objectData.contactEmail4,
            "ContactPhone 4": objectData.contactPhone4,
            "ContactName 5": objectData.contactName5,
            "ContactEmail 5": objectData.contactEmail5,
            "ContactPhone 5": objectData.contactPhone5
        };

        reportData.push(obj);
    });

    return reportData;
};

export const plantQAEntriesReportData = (response, siteData) => {
    let reportData = [];

    if (response && response.length) {
        response.forEach((objData) => {

            const getSurveyValue = (fieldName) => {
                const field = objData.surveyDetail?.find(
                    item => item.fieldName === fieldName
                );

                return field ? field.value : "";
            };

            const siteObject =
                searchArray(objData.site, siteData, "site") || {};

            reportData.push({
                "Plant": objData.plant || "",
                "Plant Cost Center": siteObject.plantHc || "",
                "Site Id": siteObject.siteId || "",
                "Site": objData.site || "",
                "Survey Date": getDateInUTCByMonth(objData.surveyDate),
                "Survey Status":
                    objData.status === 2
                        ? "Completed"
                        : "Not Completed",

                "Item": getSurveyValue("Item"),
                "Pieces Inspected":
                    convertStringToNumber(
                        getSurveyValue("Pieces Inspected")
                    ) || 0,

                "Holes":
                    convertStringToNumber(
                        getSurveyValue("Holes")
                    ) || 0,

                "Stains":
                    convertStringToNumber(
                        getSurveyValue("Stains")
                    ) || 0,

                "Poor Finish":
                    convertStringToNumber(
                        getSurveyValue("Poor Finish")
                    ) || 0,

                "Comments":
                    getSurveyValue("Comments") || "",

                "SAM":
                    objData.username ||
                    siteObject.sam ||
                    ""
            });
        });
    }

    return reportData.sort((a, b) => {
        const plantCompare = (a.Plant || "")
            .localeCompare(b.Plant || "");

        if (plantCompare !== 0) {
            return plantCompare;
        }

        return (a.Site || "")
            .localeCompare(b.Site || "");
    });
};

export const thresholdValueReportData = (data) => {
    return data.map((item) => ({
        "Threshold Value": item.value
    }));
};

export const itemCategoryReportData = (response) => {
    let reportData = [];

    if (response && response.length) {
        const sortedData = [...response].sort((a, b) => {
            if (a.isActive !== b.isActive) {
                return b.isActive - a.isActive; // Active first
            }
            return a.value.localeCompare(b.value); // Alphabetical within each group
        });

        sortedData.forEach(obj => {
            reportData.push({
                "Item Category": obj.value,
                "Active": obj.isActive ? "Yes" : "No"
            });
        });
    }

    return reportData;
};

export const imperfectionTypeReportData = (response) => {
    let reportData = [];

    if (response && response.length) {
        const sortedData = [...response].sort((a, b) => {
            if (a.isActive !== b.isActive) {
                return b.isActive - a.isActive; // Active first
            }
            return a.value.localeCompare(b.value); // Alphabetical within each group
        });

        sortedData.forEach(obj => {
            reportData.push({
                "Imperfection Type": obj.value,
                "Active": obj.isActive ? "Yes" : "No"
            });
        });
    }

    return reportData;
};

export const plantQAConfigurationReportData = (response) => {
    let reportData = [];

    if (response && response.length) {
        const sortedResponse = [...response].sort((a, b) =>
            a.name.localeCompare(b.name)
        );

        sortedResponse.forEach(objData => {

            if (!objData.inspections) return;

            objData.inspections
                .filter(item => item.isActive)
                .sort((a, b) => a.item.localeCompare(b.item))
                .forEach(item => {
                    reportData.push({
                        "Plant": objData.name,
                        "Plant Cost Center": objData.houseCode,
                        "Date Configured": getDateInUTCByMonth(objData.date),
                        "Item": item.item,
                        "Qty Required to Inspect": item.count
                    });
                });
        });
    }

    return reportData;
};


export const userReportData = (response) => {
    let reportData = [];

    if (response && response.length) {
        response.forEach(obj => {
            let objectData = Object.assign({}, obj);
            let data = {
                "User Id": objectData.uniqueId,
                "FirstName": objectData.firstName,
                "LastName": objectData.lastName,
                "Email": objectData.email,
                "PhoneNo": objectData.phoneNo,
                "Security Role": objectData.securityRole,
                "Security Group": objectData.idnAffiliation,
                "Active": objectData.active,
                "ExternalUser": objectData.externalUser,
                "Default Screen": objectData.defaultScreen,
                "Comments": objectData.comments,
            };
            reportData.push(data);
        });
    }

    return reportData;
};

export const incompleteSurveyData = (response, surveyList) => {
    let reportData = [];

    if (response && response.length) {
        response.forEach(responseObj => {
            let objectData = Object.assign({}, responseObj);
            let surveyObject = searchArrayWithActive(objectData.survey, surveyList, "title", "sendEmail");
            let obj = {
                "surveyId": objectData._id ? objectData._id : "",
                "Survey Type": objectData.survey,
                "Date": getDateInUTCByMonth(objectData.createdAt),
                "Email": objectData.clientEmail,
                "Email Contact": objectData.userContactName ? objectData.userContactName[0] : "",

            };

            reportData.push(obj);
        });
    }

    return reportData;
};

export const completedSurveyData = (response, siteData, surveyName) => {
    let reportData = [];

    if (response && response.length) {
        response.forEach(responseObj => {
            let objectData = Object.assign({}, responseObj);

            let obj = {
                "Survey Type": objectData.survey,
                "Date": getDateInUTCByMonth(objectData.createdAt),
                "Email": objectData.clientEmail,
                "Email Contact": objectData.userContactName ? objectData.userContactName[0] : "",

                "Completion Date": getDateInUTCByMonth(objectData.surveyDate)
            };

            objectData.surveyDetail.forEach((surveyDetailObj) => {
                if (surveyDetailObj.type !== "Date") {
                    obj[surveyDetailObj.fieldName] = surveyDetailObj.value;
                }
            });
            reportData.push(obj);
        });
    }

    return reportData;
};

export const surveyReportData = (response, siteData, configTitle) => {
    let reportData = [];

    if (response && response.length) {
        response.forEach(responseObj => {

            let objectData = { ...responseObj };

            let siteObject =
                searchArray(objectData.site, siteData, "site") || {};

            // Survey Status Logic
            let statusObj = "Not Completed";

            if (
                objectData.survey === "Client Satisfaction" ||
                objectData.survey === "Client Satisfaction, Multi-Person"
            ) {

                statusObj =
                    objectData.status === 2
                        ? (
                            objectData.clientEmail === "No Email"
                                ? "Completed in Person"
                                : "Completed via Email"
                        )
                        : "Not Completed";

            } else {

                statusObj =
                    objectData.status === 2
                        ? "Completed"
                        : "Not Completed";
            }

            let baseObj = {};

            if (
                objectData.survey === "Client Satisfaction" ||
                objectData.survey === "Client Satisfaction, Multi-Person"
            ) {

                // Exact export order required
                baseObj = {
                    "Survey Status": statusObj,
                    "Date": getDateInUTCByMonth(objectData.createdAt),
                    /*"Survey Type": objectData.survey,*/
                    "Email": objectData.clientEmail || "",
                    "Email Contact": objectData.userContactName
                        ? objectData.userContactName[0]
                        : "",


                    "Plant": siteObject.plant || "",
                    "Plant Cost Center": siteObject.plantHc || "",
                    "Site Id": siteObject.siteId || "",
                    "Site": siteObject.site || "",

                    "Survey Date": getDateInMonth(objectData.surveyDate),

                    // These will be filled from surveyDetail
                    "Contact Name": "",
                    "Contact Title/Dept": "",
                    "Overall Performance": "",
                    "Comments": "",
                    "SAM": ""
                };

            } else {

                // Existing order for other surveys
                baseObj = {
                    "Plant": siteObject.plant || "",
                    "Plant Cost Center": siteObject.plantHc || "",
                    "Site Id": siteObject.siteId || "",
                    "Site": siteObject.site || "",
                    "Survey Date": getDateInMonth(objectData.surveyDate),

                    "Survey Status": statusObj,

                    "Date": getDateInUTCByMonth(objectData.createdAt),
                    /*"Survey Type": objectData.survey,*/
                };
            }

            // Existing survey detail fields
            objectData.surveyDetail?.forEach((surveyDetailObj) => {

                if (configTitle.includes(surveyDetailObj.fieldName)) {

                    if (surveyDetailObj.type === "Date") {

                        baseObj[surveyDetailObj.fieldName] =
                            getDateInUTCByMonth(surveyDetailObj.value);

                    } else {

                        baseObj[surveyDetailObj.fieldName] =
                            surveyDetailObj.value;
                    }
                }
            });

            // Linen Awareness Logic
            if (
                objectData.survey === "Linen Awareness" &&
                objectData.linenData?.matrix
            ) {
                const audienceCount =
                    parseInt(baseObj["Audience Count"]) || 0;

                Object.entries(objectData.linenData.matrix).forEach(
                    ([stainType, values]) => {

                        const redBag = values.RedBag || 0;
                        const trash = values.Trash || 0;
                        const soil = values.Soil || 0;
                        const reject = values.Reject || 0;

                        reportData.push({
                            ...baseObj,

                            "Type of Stain": stainType,

                            RedBag: redBag,
                            Trash: trash,
                            Soil: soil,
                            Reject: reject,

                            "RedBag %": getPercentageValue(redBag, audienceCount),
                            "Trash %": getPercentageValue(trash, audienceCount),
                            "Soil %": getPercentageValue(soil, audienceCount),
                            "Reject %": getPercentageValue(reject, audienceCount)
                        });
                    }
                );

            } else {

                reportData.push(baseObj);
            }
        });
    }

    return reportData;
};

export const userLogsReportData = (response) => {

    let reportData = [];

    if (response && response.length) {

        response.forEach(responseObj => {

            let objectData = { ...responseObj };

            let obj = {
                "User Id": objectData.body.id,
                "Access URL": "Login",
                "Date": getDateInUTCByMonth(objectData.date),
            };

            reportData.push(obj);
        });
    }

    return reportData;
};


export const errorLogsReportData = (response) => {
    let reportData = [];

    if (response && response.length) {
        response.forEach(responseObj => {
            let objectData = Object.assign({}, responseObj);

            let obj = {
                "Date": getDateInUTCByMonth(objectData.date),
                "Method": objectData.method,
                "Access URL": objectData.url,
                "Error": objectData.error,
                "Headers": objectData.headers,
            };
            reportData.push(obj);
        });
    }

    return reportData;
};

export const getSurveyReportHeader = (response, surveyName) => {
    let reportData = [
        {
            name: "Plant",
            header: "Plant"
        },
        {
            name: "Plant Cost Center",
            header: "Plant Cost Center"
        },
        {
            name: "Site Id",
            header: "Site Id"
        },
        {
            name: "Site",
            header: "Site"
        },
        {
            name: "Survey Date",
            header: "Survey Date"
        },
        {
            name: "Survey Status",
            header: "Survey Status"
        }
    ];

    if (response && response.length) {
        response.forEach(responseObj => {
            if (responseObj.title === surveyName) {
                let objectData = Object.assign({}, responseObj);

                objectData.questions.forEach((surveyDetailObj) => {
                    if (surveyDetailObj.type !== "Date" && surveyDetailObj.active) {
                        let obj;
                        //"Linen Quality & Availability" -set the Availability (Quantity) value for report data
                        if(surveyName == "Linen Quality & Availability" && surveyDetailObj.title == "Availability"){
                            obj = {
                                name: surveyDetailObj.title,
                                header: surveyDetailObj.title
                            };
                        }else{
                            obj = {
                                name: surveyDetailObj.fieldName,
                                header: surveyDetailObj.title
                            };
                        }

                        reportData.push(obj)
                    }
                });
            }
        });
    }
    reportData.push({name:"Sam",header:"SAM"})
    return reportData;
};

export const getSurveyReportHeaderFromQuestions = (survey) => {
    let reportData=[];
    if (
        survey.title === "Client Satisfaction" ||
        survey.title === "Client Satisfaction, Multi-Person"
    ) {

        reportData = [
            {
                name: "Survey Status",
                header: "Survey Status"
            },
            {
                name: "button",
                header: "Resend Email",
                alignment: "left"
            },
            /*{
                name: "Date",
                header: "Date",
                alignment: "left"
            },*/
            {
                name: "Survey Type",
                header: "Survey Type",
                alignment: "left"
            },
            {
                name: "Email",
                header: "Email",
                alignment: "left"
            },
            {
                name: "Email Contact",
                header: "Email Contact",
                alignment: "left"
            },
            {
                name: "Plant",
                header: "Plant"
            },
            {
                name: "Plant Cost Center",
                header: "Plant Cost Center"
            },
            {
                name: "Site Id",
                header: "Site Id"
            },
            {
                name: "Site",
                header: "Site"
            },
            {
                name: "Survey Date",
                header: "Survey Date"
            },

            // MULTI PERSON FIELDS
            ...(survey.title === "Client Satisfaction, Multi-Person"
                ? [
                    {
                        name: "Contact Name 1",
                        header: "Contact Name 1",
                        alignment: "left"
                    },
                    {
                        name: "Contact Title/Dept 1",
                        header: "Contact Title/Dept 1",
                        alignment: "left"
                    },
                    {
                        name: "Contact Name 2",
                        header: "Contact Name 2",
                        alignment: "left"
                    },
                    {
                        name: "Contact Title/Dept 2",
                        header: "Contact Title/Dept 2",
                        alignment: "left"
                    },
                    {
                        name: "Contact Name 3",
                        header: "Contact Name 3",
                        alignment: "left"
                    },
                    {
                        name: "Contact Title/Dept 3",
                        header: "Contact Title/Dept 3",
                        alignment: "left"
                    },
                    {
                        name: "Contact Name 4",
                        header: "Contact Name 4",
                        alignment: "left"
                    },
                    {
                        name: "Contact Title/Dept 4",
                        header: "Contact Title/Dept 4",
                        alignment: "left"
                    },
                    {
                        name: "Contact Name 5",
                        header: "Contact Name 5",
                        alignment: "left"
                    },
                    {
                        name: "Contact Title/Dept 5",
                        header: "Contact Title/Dept 5",
                        alignment: "left"
                    }
                ]
                : [
                    {
                        name: "Contact Name",
                        header: "Contact Name",
                        alignment: "left"
                    },
                    {
                        name: "Contact Title/Dept",
                        header: "Contact Title/Dept",
                        alignment: "left"
                    }
                ]),

            {
                name: "Overall Performance",
                header: "Overall Performance",
                alignment: "left"
            },
            {
                name: "Comments",
                header: "Comments",
                alignment: "left"
            },
            {
                name: "Sam",
                header: "SAM",
                alignment: "left"
            }
        ];

    } else {

        reportData = [
            {
                name: "Plant",
                header: "Plant"
            },
            {
                name: "Plant Cost Center",
                header: "Plant Cost Center"
            },
            {
                name: "Site Id",
                header: "Site Id"
            },
            {
                name: "Site",
                header: "Site"
            },
            {
                name: "Survey Date",
                header: "Survey Date"
            },
            {
                name: "Survey Status",
                header: "Survey Status"
            }
        ];
    }
    if (survey && survey.questions && survey.questions.length) {
        survey.questions.forEach((surveyDetailObj) => {
            if (surveyDetailObj.type !== "Date" && surveyDetailObj.active) {

                let obj = {
                    name: surveyDetailObj.fieldName,
                    header: surveyDetailObj.title
                };
                reportData.push(obj)
            }
        });
    }
    if (survey?.title === "Linen Awareness") {
        // remove existing dynamic fields that may duplicate order
        reportData = reportData.filter(
            (item) =>
                ![
                    "Type",
                    "Audience Count",
                    "Comments",
                    "Type of Stain",
                    "RedBag",
                    "Trash",
                    "Soil",
                    "Reject",
                    "RedBag %",
                    "Trash %",
                    "Soil %",
                    "Reject %",
                    "Sam"
                ].includes(item.header) &&
                ![
                    "Type",
                    "Audience Count",
                    "Comments",
                    "Type of Stain",
                    "RedBag",
                    "Trash",
                    "Soil",
                    "Reject",
                    "RedBag %",
                    "Trash %",
                    "Soil %",
                    "Reject %",
                    "Sam"
                ].includes(item.name)
        );

        return [
            ...reportData,
            { name: "Type", header: "Type" },
            { name: "Audience Count", header: "Audience Count" },
            { name: "Comments", header: "Comments" },
            { name: "Type of Stain", header: "Type of Stain" },
            { name: "RedBag", header: "RedBag" },
            { name: "Trash", header: "Trash" },
            { name: "Soil", header: "Soil" },
            { name: "Reject", header: "Reject" },
            { name: "RedBag %", header: "RedBag %" },
            { name: "Trash %", header: "Trash %" },
            { name: "Soil %", header: "Soil %" },
            { name: "Reject %", header: "Reject %" },
            { name: "Sam", header: "SAM" }
        ];
    }
    reportData.push({name:"Sam",header:"SAM"})
    return reportData;
};

export const getOnlySurveyReportHeader = (response, surveyName) => {
    let reportData = [
        {
            name: "Survey Date",
            header: "Survey Date"
        }
    ];

    if (response && response.length) {
        response.forEach(responseObj => {
            if (responseObj.title === surveyName) {
                let objectData = Object.assign({}, responseObj);
                const allowedImperfections = ["Holes", "Stains", "Poor Finish"];

                let surveyQuestions = sortArrayOfObjectByNumber(
                    objectData.questions,
                    "order"
                );

                surveyQuestions.forEach((surveyDetailObj) => {
                    if (
                        surveyDetailObj.type !== "Date" &&
                        surveyDetailObj.active &&
                        surveyDetailObj.isRequire
                    ) {
                        reportData.push({
                            name: surveyDetailObj.fieldName,
                            header: surveyDetailObj.title
                        });
                    }

                    if (
                        surveyDetailObj.type !== "Date" &&
                        surveyDetailObj.active &&
                        (
                            surveyDetailObj.fieldName === "Summary" ||
                            surveyDetailObj.fieldName === "Comments"
                        )
                    ) {
                        if (
                            !reportData.some(
                                item => item.name === surveyDetailObj.fieldName
                            )
                        ) {
                            reportData.push({
                                name: surveyDetailObj.fieldName,
                                header: surveyDetailObj.title
                            });
                        }
                    }

                    if (surveyDetailObj.fieldName === "Specify Other Dept") {
                        if (
                            !reportData.some(
                                item => item.name === surveyDetailObj.fieldName
                            )
                        ) {
                            reportData.push({
                                name: surveyDetailObj.fieldName,
                                header: surveyDetailObj.title
                            });
                        }
                    }

                    if (
                        (
                            surveyName === "Onsite Linen Inspection" ||
                            surveyName === "Onsite Imperfections"
                        ) &&
                        surveyDetailObj.type !== "Date" &&
                        surveyDetailObj.active &&
                        allowedImperfections.includes(
                            surveyDetailObj.fieldName
                        )
                    ) {
                        if (
                            !reportData.some(
                                item => item.name === surveyDetailObj.fieldName
                            )
                        ) {
                            reportData.push({
                                name: surveyDetailObj.fieldName,
                                header: surveyDetailObj.title
                            });
                        }
                    }
                });

                // MOVE THIS OUTSIDE LOOP
                if (surveyName === "Linen Awareness") {
                    const fixedColumns = [
                        { name: "Type of Stain", header: "Type of Stain" },
                        { name: "RedBag", header: "RedBag" },
                        { name: "Trash", header: "Trash" },
                        { name: "Soil", header: "Soil" },
                        { name: "Reject", header: "Reject" },
                        { name: "RedBag %", header: "RedBag %" },
                        { name: "Trash %", header: "Trash %" },
                        { name: "Soil %", header: "Soil %" },
                        { name: "Reject %", header: "Reject %" }
                    ];

                    fixedColumns.forEach((col) => {
                        if (
                            !reportData.some(
                                item => item.name === col.name
                            )
                        ) {
                            reportData.push(col);
                        }
                    });

                    const preferredOrder = [
                        "Survey Date",
                        "Audience Count",
                        "Type",
                        "Comments",
                        "Type of Stain",
                        "RedBag",
                        "Trash",
                        "Soil",
                        "Reject",
                        "RedBag %",
                        "Trash %",
                        "Soil %",
                        "Reject %"
                    ];

                    reportData = preferredOrder
                        .map((headerName) =>
                            reportData.find(
                                item =>
                                    item.name === headerName ||
                                    item.header === headerName
                            )
                        )
                        .filter(Boolean);
                }
            }
        });
    }

    return reportData;
};

export const getSurveyReportBody = (response, siteData, surveyName, key, sites, linenItem, linenImperfection) => {
    let reportData = [];
    if (response && response.length) {
        response.forEach(responseObj => {
            let objectData = Object.assign({}, responseObj);

            let flag = sites.includes(responseObj[key]);
            let isQuantity = false;
            if (objectData.survey === surveyName && flag && objectData.status === 2) {
                if(objectData.survey == "Linen Quality & Availability"){
                    isQuantity = true;
                }
                if(linenItem && linenItem.length) {
                    let flag = false;
                    objectData.surveyDetail.forEach((surveyDetailObject) => {
                        if (surveyDetailObject.fieldName === "Item") {
                            flag = linenItem.includes(surveyDetailObject.value);
                        }
                    });

                    if (flag) {
                        let siteObject = searchArray(objectData.site, siteData, "site");
                        let obj = {
                            "Plant": siteObject.plant,
                            "Plant Cost Center": siteObject.plantHc,
                            "Site Id": siteObject.siteId,
                            "Site": siteObject.site,
                            "Survey Date": getDateInUTCByMonth(objectData.surveyDate),
                            "Survey Status": objectData.status === 2 ? "Completed" : "Not Completed"
                        };

                        if (objectData.surveyDetail && objectData.surveyDetail.length) {
                            objectData.surveyDetail.map(surveyObj => {
                                let surveyDetail = Object.assign({}, surveyObj);
                                //&& surveyDetail.value - remove to display the data is null headers into Excel file
                                if (surveyDetail && surveyDetail.fieldName) {
                                    if (surveyDetail.fieldName === "Pieces Inspected") {
                                        obj[surveyDetail.fieldName] = surveyDetail.value;
                                    }

                                    if (surveyDetail.type !== "Number" && surveyDetail.type !== "Date") {
                                        obj[surveyDetail.fieldName] = surveyDetail.value;
                                    }

                                    if (surveyDetail.type === "Number" && surveyDetail.fieldName !== "Pieces Inspected") {
                                        linenImperfection.forEach((linenImperfectionObj) => {
                                            if (surveyDetail.fieldName == linenImperfectionObj) {
                                                obj[surveyDetail.fieldName] = surveyDetail.value;                                            }
                                        });
                                    }
                                }
                            });
                        }


                        obj["Sam"] = objectData.username || siteObject.sam;
                        reportData.push(obj);
                    }
                } else {
                    let siteObject = searchArray(objectData.site, siteData, "site");
                    let obj = {
                        "Plant": siteObject.plant,
                        "Plant Cost Center": siteObject.plantHc,
                        "Site Id": siteObject.siteId,
                        "Site": siteObject.site,
                        "Survey Date": getDateInUTCByMonth(objectData.surveyDate),
                        "Survey Status": objectData.status === 2 ? "Completed" : "Not Completed"
                    };

                    if (objectData.surveyDetail && objectData.surveyDetail.length) {
                        objectData.surveyDetail.map(surveyObj => {
                            let surveyDetail = Object.assign({}, surveyObj);

//                            if (surveyDetail && surveyDetail.fieldName && surveyDetail.value) {  //remove the surveyDetail.value to get all headers to display in the excel file
                            if (surveyDetail && surveyDetail.fieldName ) {
                                if (surveyDetail.type !== "Date") {
                                    //Linen Quality & Availability -set the value of Report Excel header change Quantity to Availability
                                    if(surveyDetail.fieldName == "Quantity" && isQuantity){
                                        surveyDetail.fieldName = surveyDetail.title;
                                        obj[surveyDetail.fieldName] = surveyDetail.value;
                                        console.log("#587 surveyDetail.fieldName " + surveyDetail.fieldName);
                                    }else{
                                        obj[surveyDetail.fieldName] = surveyDetail.value;
                                    }

                                }
                            }
                        });
                    }
                    //Add the Sam column data to objectData array for Linen Quality & Availability
                   /* if (objectData.survey === "Linen Quality & Availability" ||
                        objectData.survey === "Dept Linen Feedback" ||
                        objectData.survey === "Onsite Imperfections" ||
                        objectData.survey === "Client Sat Score"
                ) {*/
                        obj["Sam"] = objectData.username || siteObject.sam;
                  //  }
                    reportData.push(obj);
                }
            }
            isQuantity = false;
        });
    }

    return reportData;
};

export const getOnSiteReport = (response, siteData, surveyName, survey) => {
    let reportData = [];
    let linenImperfection = [];
    let linenItem = [];
    let rowHeader = [];

    if (survey.questions && survey.questions.length) {
        (survey.questions).forEach((detail) => {
            if (detail.type === "Number" && detail.fieldName !== "Pieces Inspected" && detail.active) {
                linenImperfection.push(detail.fieldName);
            }

            if (detail.fieldName === "Item" && detail.active) {
                detail.answers.forEach((answersObj) => {
                    linenItem.push(answersObj.displayValue);
                });

            }

            if (detail.active) {
                rowHeader.push(detail.fieldName);
            }
        });
    }

    let surveyHeader = getSurveyReportHeaderFromQuestions(survey);


    if (response && response.length) {
        response.forEach(responseObj => {
            let objectData = Object.assign({}, responseObj);

            if (objectData.survey === surveyName && objectData.status === 2) {

                if(linenItem && linenItem.length) {
                    let linenItemFlag = false;
                    objectData.surveyDetail.forEach((surveyDetailObject) => {
                        if (surveyDetailObject.fieldName === "Item") {
                            linenItemFlag = linenItem.includes(surveyDetailObject.value);
                        }
                    });

                    if (linenItemFlag) {
                        let siteObject = searchArray(objectData.site, siteData, "site");
                        // ❌ Skip invalid records
                        if (
                            !siteObject ||
                            !isValid(siteObject.plant) ||
                            !isValid(siteObject.plantHc) ||
                            !isValid(siteObject.siteId) ||
                            !isValid(siteObject.site)
                        ) {
                            return;
                        }
                        let obj = {
                            "Plant": siteObject.plant,
                            "Plant Cost Center": siteObject.plantHc,
                            "Site Id": siteObject.siteId,
                            "Site": siteObject.site,
                            "Survey Date": getDateInUTCByMonth(objectData.surveyDate),
                            "Survey Status": objectData.status === 2 ? "Completed" : "Not Completed"
                        };

                        if (objectData.surveyDetail && objectData.surveyDetail.length) {
                            objectData.surveyDetail.map(surveyObj => {
                                let surveyDetail = Object.assign({}, surveyObj);
                                let surveyFieldName = searchArray(surveyDetail.fieldName, surveyHeader, "name");

                                //&& surveyDetail.value - remove to display the data is null headers into Excel file
                                if (surveyDetail && surveyDetail.fieldName && surveyFieldName) {
                                    if (surveyDetail.fieldName === "Pieces Inspected") {
                                        obj[surveyFieldName.header] = surveyDetail.value;
                                    }

                                    if (surveyDetail.type !== "Number" && surveyDetail.type !== "Date") {
                                        obj[surveyFieldName.header] = surveyDetail.value;
                                    }

                                    if (surveyDetail.type === "Number" && surveyDetail.fieldName !== "Pieces Inspected") {
                                        linenImperfection.forEach((linenImperfectionObj) => {
                                            if (surveyDetail.fieldName == linenImperfectionObj) {
                                                obj[surveyFieldName.header] = surveyDetail.value;                                            }
                                        });
                                    }
                                }
                            });
                        }
                        //Add the Sam column data to objectData array for Onsite Linen Inspection
                        if (objectData.survey === "Onsite Linen Inspection" ||
                            objectData.survey === "Onsite Imperfections" ) {
                            obj["Sam"] = objectData.username || siteObject.sam;
                        }
                        reportData.push(obj);
                    }
                }
            }
        });
    }
    reportData.sort((a, b) => {
        const normalize = (val) =>
            (val || "")
                .toString()
                .trim()
                .toLowerCase();

        const plantA = normalize(a["Plant"]);
        const plantB = normalize(b["Plant"]);

        // Primary: Plant
        if (plantA !== plantB) {
            return plantA.localeCompare(plantB);
        }

        // Secondary: Site
        const siteA = normalize(a["Site"]);
        const siteB = normalize(b["Site"]);

        return siteA.localeCompare(siteB);
    });
    return reportData;
};

const isValid = (val) => val !== undefined && val !== null && val !== "";

export const getLinenQualityReport = (isCombinedSurvey ,response, siteData, surveyName, survey) => {
    let reportData = [];
    /*let linenItem = [];
    let rowHeader = [];

    if (survey.questions && survey.questions.length) {
        (survey.questions).forEach((detail) => {
            if (detail.fieldName === "Department" && detail.active) {
                detail.answers.forEach((answersObj) => {
                    linenItem.push(answersObj.displayValue);
                });

            }

            if (detail.active) {
                rowHeader.push(detail.fieldName);
            }
        });
    }*/

    let surveyHeader = getSurveyReportHeaderFromQuestions(survey);

    if (response && response.length) {
        response.forEach(responseObj => {
            let objectData = Object.assign({}, responseObj);
            let statusObj;
            if (objectData.survey === surveyName ) {
                
                let siteObject = searchArray(objectData.site, siteData, "site");

                if (
                    !siteObject ||
                    !isValid(siteObject.plant) ||
                    !isValid(siteObject.plantHc) ||
                    !isValid(siteObject.siteId) ||
                    !isValid(siteObject.site)
                ) {
                    return;
                }
                   if(surveyName === "Client Satisfaction" || surveyName === "Client Satisfaction, Multi-Person") {
                        statusObj = objectData.status === 2 ? (objectData.clientEmail === "No Email" ? "Completed in Person" : "Completed via Email") : "Not Completed";
                    }else{
                       statusObj = objectData.status === 2 ? "Completed" : "Not Completed" ;
                   }

                let obj = {};

                if (
                    surveyName === "Client Satisfaction"
                ) {
                    // ONLY required headers
                    obj = {
                        "Survey Status": statusObj,
                        "Date": getDateInUTCByMonth(objectData.createdAt),
                        ...(isCombinedSurvey && {
                         "Survey Type": objectData.survey,
                         }),
                        "Email": objectData.clientEmail,
                        "Email Contact": objectData.userContactName ? objectData.userContactName[0] : "",

                        "Plant": siteObject.plant,
                        "Plant Cost Center": siteObject.plantHc,
                        "Site Id": siteObject.siteId,
                        "Site": siteObject.site,
                        "Survey Date": getDateInUTCByMonth(objectData.surveyDate),
                    };
                }else if( surveyName === "Client Satisfaction, Multi-Person" ){
                    // ONLY required headers
                    obj = {
                        "Survey Status": statusObj,
                        "Date": getDateInUTCByMonth(objectData.createdAt),
                        ...(isCombinedSurvey && {
                            "Survey Type": objectData.survey,
                        }),
                        "Email": objectData.clientEmail,
                        "Email Contact": objectData.userContactName ? objectData.userContactName[0] : "",

                        "Plant": siteObject.plant,
                        "Plant Cost Center": siteObject.plantHc,
                        "Site Id": siteObject.siteId,
                        "Site": siteObject.site,
                        "Survey Date": getDateInUTCByMonth(objectData.surveyDate),
                    };
                }
                else {
                    // ALL other surveys
                    obj = {
                        "Plant": siteObject.plant,
                        "Plant Cost Center": siteObject.plantHc,
                        "Site Id": siteObject.siteId,
                        "Site": siteObject.site,
                        "Survey Date": getDateInUTCByMonth(objectData.surveyDate),
                        "Survey Status": statusObj,

                    };
                }
                
                if (objectData.surveyDetail && objectData.surveyDetail.length) {
                    objectData.surveyDetail.map(surveyObj => {
                        let surveyDetail = Object.assign({}, surveyObj);
                        let surveyFieldName = searchArray(surveyDetail.fieldName, surveyHeader, "name");

                        //&& surveyDetail.value - remove to display the data is null headers into Excel file
                        if (surveyDetail && surveyDetail.fieldName && surveyFieldName) {
                            obj[surveyFieldName.header] = surveyDetail.value ?? ""; // set empty string if null
                        }
                    });
                }

                // ONLY for Linen Awareness
                if (
                    surveyName === "Linen Awareness" &&
                    objectData.linenData &&
                    objectData.linenData.matrix
                ) {
                    const audienceCount =
                        parseInt(obj["Audience Count"]) || 0;

                    Object.entries(objectData.linenData.matrix).forEach(
                        ([stainType, values]) => {

                            const redBag = values.RedBag ?? 0;
                            const trash = values.Trash ?? 0;
                            const soil = values.Soil ?? 0;
                            const reject = values.Reject ?? 0;

                            reportData.push({
                                ...obj,
                                "Type of Stain": stainType,
                                "Audience Count": audienceCount,

                                "RedBag": redBag,
                                "Trash": trash,
                                "Soil": soil,
                                "Reject": reject,

                                "RedBag %": getPercentageValue(redBag, audienceCount),
                                "Trash %": getPercentageValue(trash, audienceCount),
                                "Soil %": getPercentageValue(soil, audienceCount),
                                "Reject %": getPercentageValue(reject, audienceCount),
                                "SAM": objectData.username || siteObject.sam
                            });
                        }
                    );
                } else {
                    obj["SAM"] = objectData.username || siteObject.sam;
                    reportData.push(obj);
                }
            }
        });
    }
    reportData.sort((a, b) => {
        const normalize = (val) =>
            (val || "")
                .toString()
                .trim()          // ✅ remove spaces
                .toLowerCase();  // ✅ normalize case

        const plantA = normalize(a["Plant"]);
        const plantB = normalize(b["Plant"]);

        // Sort by Plant
        if (plantA !== plantB) {
            return plantA.localeCompare(plantB);
        }

        // Secondary sort by Site
        const siteA = normalize(a["Site"]);
        const siteB = normalize(b["Site"]);

        return siteA.localeCompare(siteB);
    });

    return reportData;
};

export const getClientStatReport = (response, siteData, surveyName, survey) => {
    let reportData = [];
    let linenItem = [];
    let rowHeader = [];
   /* if (survey.questions && survey.questions.length) {
        (survey.questions).forEach((detail) => {
            if (detail.fieldName === "Contact Title/Dept" && detail.active) {
                detail.answers.forEach((answersObj) => {
                    linenItem.push(answersObj.displayValue);
                });

            }

            if (detail.active) {
                rowHeader.push(detail.fieldName);
            }
        });
    }*/

    let surveyHeader = getSurveyReportHeaderFromQuestions(survey);


    if (response && response.length) {
        response.forEach(responseObj => {
            let objectData = Object.assign({}, responseObj);
            if (objectData.survey === surveyName && objectData.status === 2) {
                let siteObject = searchArray(objectData.site, siteData, "site");
                let obj = {
                    "Plant": siteObject.plant,
                    "Plant Cost Center": siteObject.plantHc,
                    "Site Id": siteObject.siteId,
                    "Site": siteObject.site,
                    "Survey Date": getDateInUTCByMonth(objectData.surveyDate),
                    "Survey Status": objectData.status === 2 ? "Completed" : "Not Completed"
                };

                if (objectData.surveyDetail && objectData.surveyDetail.length) {
                    objectData.surveyDetail.map(surveyObj => {
                        let surveyDetail = Object.assign({}, surveyObj);
                        let surveyFieldName = searchArray(surveyDetail.fieldName, surveyHeader, "name");

                        //&& surveyDetail.value - remove to display the data is null headers into Excel file
                        if (surveyDetail && surveyDetail.fieldName && surveyFieldName) {
                            obj[surveyFieldName.header] = surveyDetail.value;
                        }
                    });
                }
                obj["SAM"] = siteObject?.sam ?? "";
                reportData.push(obj);
            }
        });
    }

    return reportData;
};

export const getPercentageValue = (value, total) => {
    const numValue = parseInt(value) || 0;
    const numTotal = parseInt(total) || 0;

    if (numTotal === 0) return "0%";

    return `${((numValue / numTotal) * 100).toFixed(1)}%`;
};

export const getOnSiteTableData = (response, siteData, surveyName, survey) => {
    let reportData = [];
    let linenImperfection = [];
    let linenItem = [];
    let rowHeader = [];

    if (survey.questions && survey.questions.length) {
        (survey.questions).forEach((detail) => {
            if (detail.type === "Number" && detail.fieldName !== "Pieces Inspected" && detail.active) {
                linenImperfection.push(detail.fieldName);
            }

            if (detail.fieldName === "Item" && detail.active) {
                detail.answers.forEach((answersObj) => {
                    linenItem.push(answersObj.displayValue);
                });

            }

            if (detail.active) {
                rowHeader.push(detail.fieldName);
            }
        });
    }

    let surveyHeader = getSurveyReportHeaderFromQuestions(survey);


    if (response && response.length) {
        response.forEach(responseObj => {
            let objectData = Object.assign({}, responseObj);

            if (objectData.survey === surveyName && objectData.status === 2) {

                if(linenItem && linenItem.length) {
                    let linenItemFlag = false;
                    objectData.surveyDetail.forEach((surveyDetailObject) => {
                        if (surveyDetailObject.fieldName === "Item") {
                            linenItemFlag = linenItem.includes(surveyDetailObject.value);
                        }
                    });

                    if (linenItemFlag) {
                        let siteObject = searchArray(objectData.site, siteData, "site");
// ❌ Skip invalid rows
                        if (
                            !siteObject ||
                            !isValid(siteObject.plant) ||
                            !isValid(siteObject.plantHc) ||
                            !isValid(siteObject.siteId) ||
                            !isValid(siteObject.site)
                        ) {
                            return;
                        }

                        let obj = {
                            "Plant": siteObject.plant,
                            "Plant Cost Center": siteObject.plantHc,
                            "Site Id": siteObject.siteId,
                            "Site": siteObject.site,
                            "Survey Date": getDateInUTCByMonth(objectData.surveyDate),
                            "Survey Status": objectData.status === 2 ? "Completed" : "Not Completed",
                            "userId":objectData.userId,
                            "id":objectData._id
                        };

                        if (objectData.surveyDetail && objectData.surveyDetail.length) {
                            objectData.surveyDetail.map(surveyObj => {
                                let surveyDetail = Object.assign({}, surveyObj);
                                let surveyFieldName = searchArray(surveyDetail.fieldName, surveyHeader, "name");


                                if (surveyDetail && surveyDetail.fieldName && surveyFieldName) {
                                    if (surveyDetail.fieldName === "Pieces Inspected") {
                                        obj[surveyFieldName.header] = surveyDetail.value;
                                    }

                                    if (surveyDetail.type !== "Number" && surveyDetail.type !== "Date") {
                                        obj[surveyFieldName.header] = surveyDetail.value;
                                    }

                                    if (surveyDetail.type === "Number" && surveyDetail.fieldName !== "Pieces Inspected") {
                                        linenImperfection.forEach((linenImperfectionObj) => {
                                            if (surveyDetail.fieldName == linenImperfectionObj) {
                                                obj[surveyFieldName.name] = surveyDetail.value;                                            }
                                        });
                                    }
                                }
                            });
                        }

                       /* if (
                            objectData.survey?.trim() === "Onsite Linen Inspection" ||
                            objectData.survey?.trim() === "Onsite Imperfections"
                        ) {*/
                            obj["Sam"] = objectData.username || siteObject?.sam || "";
                       // }
                        reportData.push(obj);
                    }
                }
            }
        });
    }

    reportData.sort((a, b) => {
        const normalize = (val) =>
            (val || "")
                .toString()
                .trim()
                .toLowerCase();

        const plantA = normalize(a["Plant"]);
        const plantB = normalize(b["Plant"]);

        // Primary: Plant
        if (plantA !== plantB) {
            return plantA.localeCompare(plantB);
        }

        // Secondary: Site
        const siteA = normalize(a["Site"]);
        const siteB = normalize(b["Site"]);

        return siteA.localeCompare(siteB);
    });

    return reportData;
};

export const getCommonTableData = (response, siteData, surveyName, survey) => {
    let reportData = [];
    let surveyHeader = getSurveyReportHeaderFromQuestions(survey);
    if (response && response.length) {
        response.forEach(responseObj => {
            let objectData = Object.assign({}, responseObj);
            if (objectData.survey === surveyName) {

                let siteObject = searchArray(objectData.site, siteData, "site");

                if (
                    !siteObject ||
                    !isValid(siteObject.plant) ||
                    !isValid(siteObject.plantHc) ||
                    !isValid(siteObject.siteId) ||
                    !isValid(siteObject.site)
                ) {
                    return; // skip this row
                }

                let statusObj;
                if(surveyName === "Client Satisfaction" || surveyName === "Client Satisfaction, Multi-Person") {
                    statusObj = objectData.status === 2 ? (objectData.clientEmail === "No Email" ? "Completed in Person" : "Completed via Email") : "Not Completed";
                }else{
                    statusObj = objectData.status === 2 ? "Completed" : "Not Completed" ;
                }

                let obj = {
                    "Date": getDateInUTCByMonth(objectData.createdAt),   // FIX
                    "Survey Type": objectData.survey,
                    "Plant": siteObject.plant,
                    "Plant Cost Center": siteObject.plantHc,
                    "Site Id": siteObject.siteId,
                    "Site": siteObject.site,
                    "Survey Date": getDateInUTCByMonth(objectData.surveyDate),
                    "Survey Status": statusObj,
                    "userId":objectData.userId,
                    "id":objectData._id,
                    "Email Contact": objectData.userContactName ? objectData.userContactName[0] : "",
                    "Email": objectData.clientEmail,
                };
                
                if (objectData.surveyDetail && objectData.surveyDetail.length) {
                    objectData.surveyDetail.map(surveyObj => {
                        let surveyDetail = Object.assign({}, surveyObj);
                        let surveyFieldName = searchArray(surveyDetail.fieldName, surveyHeader, "name");
                        
                        
                        if (surveyDetail && surveyDetail.fieldName && surveyFieldName) {
                            obj[surveyFieldName.name] = surveyDetail.value;                         }
                        });
                    }
                     obj["Sam"] = objectData.username || siteObject.sam;

// ONLY for Linen Awareness
                if (
                    surveyName === "Linen Awareness" &&
                    objectData.linenData?.matrix
                ) {
                    const audienceCount =
                        parseInt(obj["Audience Count"]) || 0;

                    const getPercentage = (value) =>
                        audienceCount > 0
                            ? `${((value / audienceCount) * 100).toFixed(1)}%`
                            : "0%";

                    const matrixEntries = Object.entries(
                        objectData.linenData.matrix
                    );

                    if (matrixEntries.length) {

                        matrixEntries.forEach(([stainType, values]) => {

                            const redBag = values.RedBag ?? 0;
                            const trash = values.Trash ?? 0;
                            const soil = values.Soil ?? 0;
                            const reject = values.Reject ?? 0;

                            reportData.push({
                                ...obj,
                                "Audience Count": audienceCount,
                                "Type of Stain": stainType,

                                RedBag: redBag,
                                Trash: trash,
                                Soil: soil,
                                Reject: reject,

                                "RedBag %": getPercentage(redBag),
                                "Trash %": getPercentage(trash),
                                "Soil %": getPercentage(soil),
                                "Reject %": getPercentage(reject)
                            });
                        });

                        return; // IMPORTANT
                    }
                } else {
                    reportData.push(obj);
                }
            }
        });
    }

    if (
        surveyName !== "Client Satisfaction" &&
        surveyName !== "Client Satisfaction, Multi-Person"
    ) {
        reportData.sort((a, b) => {
            const normalize = (val) =>
                (val || "")
                    .toString()
                    .trim()
                    .toLowerCase();

            const plantA = normalize(a["Plant"]);
            const plantB = normalize(b["Plant"]);

            // Primary: Plant
            if (plantA !== plantB) {
                return plantA.localeCompare(plantB);
            }

            // Secondary: Site
            const siteA = normalize(a["Site"]);
            const siteB = normalize(b["Site"]);

            if (siteA !== siteB) {
                return siteA.localeCompare(siteB);
            }

            // Optional: Date descending
            return new Date(b["Survey Date"]) - new Date(a["Survey Date"]);
        });
    }

    return reportData;
};